import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState, AppMessage } from '@/types'; // Import types

// **Initial State**
const initialState: AppState = {
  version: null,
  messages: [],
  isMobile: false,
};

// **Slice**
const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // Set App Version
    appSetVersion: (state, action: PayloadAction<string | null>) => {
      state.version = action.payload;
    },

    // Add a Message
    appSetMessage: (state, action: PayloadAction<AppMessage>) => {
      state.messages.push(action.payload);
    },

    // Clear All Messages
    appClearMessages: (state) => {
      state.messages = [];
    },

    // Set Mobile Status
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
  },
});

// **Export Actions**
export const { appSetVersion, appSetMessage, appClearMessages, setIsMobile } = appSlice.actions;

// **Export Reducer**
export default appSlice.reducer;